import { CdpaButtonComponent, CdpaButtonId } from "../../../common/components/cdpaButton.component";
import { CdpaMultiFieldInput } from "../cdpaMultiFieldInput/cdpa-multi-field-input";
import { attachValidationOnSubmitClick } from "../formHelpers/formHelpers";
import { FormId } from "../common/formId";
import "./device-login.scss";
export class DeviceLogin {
    constructor() {
        const form = document.getElementById(FormId.DeviceLogin);
        const submitButton = new CdpaButtonComponent(CdpaButtonId.DeviceCode);
        const codeInput = new CdpaMultiFieldInput("device-code__input", "device-code-wrapper", "device-code__label", true);
        attachValidationOnSubmitClick(submitButton, form, [codeInput]);
    }
}
